import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "extensionSummaryCDR/listSummary",
  pdfDownload: "extensionSummaryCDR/generateSummaryAndDownloadPdf",
  csvDownload: "/extensionSummaryCDR/downloadCSVExtensionSummary",
};

const getColumns = () => {
  return [
    {
      Header: "Extension No",
      accessor: "extension",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Extension Name",
      accessor: "extensionName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Call",
      accessor: "totalCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Answered",
      accessor: "answered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Unanswered",
      accessor: "unanswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Talk Time(HH:MM:SS)",
      accessor: "callDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      dateTime: false,
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Avg Talk Time (HH:MM:SS)",
      accessor: "avgCallDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      dateTime: false,
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Ring Time(HH:MM:SS)",
      accessor: "ringDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      sortDisable: true,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Avg Ring Time(HH:MM:SS)",
      accessor: "avgRingDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      sortDisable: true,
      dataType: "integer",
      dateTime: false,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Date",
      accessor: "callDate",
      displayInList: false,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      sortDisable: true,
      dateTime: false,
      downloadReports: false,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
